/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	
	// ユーザーエージェント確認
	__webpack_require__(2);
	
	
	/********************************
	* DOM読み込み完了
	*/
	$( function(){
	    'use strict';
	
	    // 画像の遅延読み込み
	    $('img.js-lazy').lazyload({effect:'fadeIn'});
	
	    // 画像ポップアップ
	     $('a.js-magnific').magnificPopup({
	        type: 'image'
	     });
	
	    // サイドバーの位置固定
	    $.SygFixScroll( '.js-sticky', {
	        parent: '.js-sticky-parent'
	    } );
	
	    // メニュー制御
	    __webpack_require__(3);
	
	    // タブ制御
	    var CaracolTab = __webpack_require__(4);
	    new CaracolTab('.js-ccltab');
	
	    // スクロール位置と方向によって反応するクラス
	    var CaracolScrollAmount = __webpack_require__(5)
	    new CaracolScrollAmount('.js-scroll-amount');
	
	    // ページスクロール
	    var CaracolPageScroll = __webpack_require__(6);
	    new CaracolPageScroll('.js-pagescroll');
	
	    // SNSボタン
	    __webpack_require__(7).set_share_button('.js-sns-btn');;
	
	
	});
	
	
	


/***/ },
/* 2 */
/***/ function(module, exports) {

	/*****************************
	* ブラウザ情報を取得する
	*/
	
	exports.isMobile = (function(){ 'use strict'; return isMobile; })();
	exports.browser = (function(){ 'use strict'; return browser; })();
	
	
	var isMobile = checkMobile();
	var browser = getBrowser();
	
	/****************************
	* モバイル判定
	*/
	function checkMobile(){
	    'use strict';
	    var agent = navigator.userAgent;
	
	    if(agent.search(/iPhone/) != -1 || agent.search(/iPad/) != -1 || agent.search(/iPod/) != -1 || agent.search(/Android/) != -1){
	        $('body').addClass('isMobile');
	        $.isMobile = true;
	        return true;
	    }else{
	        $('body').addClass('isPC');
	        $.isMobile = false;
	        return false;
	    }
	}
	
	/****************************
	* ブラウザ判別
	*/
	function getBrowser(){
	    'use strict';
	
	    var ua = window.navigator.userAgent.toLowerCase();
	    var ver = window.navigator.appVersion.toLowerCase();
	    var name = 'unknown';
	
	    if (ua.indexOf("msie") != -1){
	        if (ver.indexOf("msie 6.") != -1){
	            name = 'ie6';
	        }else if (ver.indexOf("msie 7.") != -1){
	            name = 'ie7';
	        }else if (ver.indexOf("msie 8.") != -1){
	            name = 'ie8';
	        }else if (ver.indexOf("msie 9.") != -1){
	            name = 'ie9';
	        }else if (ver.indexOf("msie 10.") != -1){
	            name = 'ie10';
	        }else{
	            name = 'ie';
	        }
	    }else if(ua.indexOf('trident/7') != -1){
	        name = 'ie11';
	    }else if (ua.indexOf('chrome') != -1){
	        name = 'chrome';
	    }else if (ua.indexOf('safari') != -1){
	        name = 'safari';
	    }else if (ua.indexOf('opera') != -1){
	        name = 'opera';
	    }else if (ua.indexOf('firefox') != -1){
	        name = 'firefox';
	    }
	    return name;
	}
	
	


/***/ },
/* 3 */
/***/ function(module, exports) {

	exports.set_menu = (function(){
	    'use strict';
	
	    // スマホ版のリストメニュー
	    $('.js-menu-bar-list').append(
	        '<div class="widget widget_post-list widget_popular">' +
	        $('.widget_popular').html() + '</div>' );
	
	    // 複製するとタブ設定が重複してしまうので、差し換える
	    $('.js-menu-bar-list .widget_popular .widget__tab').data('ccltab-content', '.menu-bar__content_list .js-ccltab-content_ranking');
	
	    if( $('.widget_recent').length >= 1 ){
	        $('.js-menu-bar-list').append(
	            '<div class="widget widget_post-list widget_recent">' +
	            $('.widget_recent').html() + '</div>' );
	    }
	
	    $('.js-menu-bar-list').append(
	        '<div class="widget widget_post-list widget_recommend">' +
	        $('.widget_recommend').html() + '</div>' );
	
	    // メニューの開閉
	    $('.js-menu-menu-open').click(function(event){
	        if( $(this).hasClass('active') ){
	            menubar_switch( 'menu', false );
	        }else{
	            menubar_switch( 'menu', true );
	        }
	        // return false;
	        event.preventDefault();
	    });
	
	    // リストの開閉
	    $('.js-menu-list-open').click(function(event){
	        if( $(this).hasClass('active') ){
	            menubar_switch( 'list', false );
	        }else{
	            menubar_switch( 'list', true );
	        }
	        // return false;
	        event.preventDefault();
	    });
	
	    // メニューの切り替え設定がややこしいからまとめた
	    function menubar_switch( target, isOpen ){
	        var $target_btn, $target_bar, $untarget_btn, $untarget_bar;
	
	        if( target == 'menu' ){
	            $target_btn = $('.js-menu-menu-open');
	            $target_bar = $('.js-menu-bar-menu');
	            $untarget_btn = $('.js-menu-list-open');
	            $untarget_bar = $('.js-menu-bar-list');
	        }else{
	            $target_btn = $('.js-menu-list-open');
	            $target_bar = $('.js-menu-bar-list');
	            $untarget_btn = $('.js-menu-menu-open');
	            $untarget_bar = $('.js-menu-bar-menu');
	        }
	
	        if( isOpen ){
	            $target_btn.addClass('active');
	            $target_bar.removeClass('menu-bar__content_init');
	            $target_bar.removeClass('menu-bar__content_close');
	            $target_bar.addClass('menu-bar__content_open');
	            $untarget_btn.removeClass('active');
	
	            if( !$untarget_bar.hasClass('menu-bar__content_init') ){
	                $untarget_bar.addClass('menu-bar__content_close');
	                $untarget_bar.removeClass('menu-bar__content_open');
	            }
	
	        }else{
	            $target_btn.removeClass('active');
	            $target_bar.addClass('menu-bar__content_close');
	            $target_bar.removeClass('menu-bar__content_open');
	        }
	    }
	
	})();


/***/ },
/* 4 */
/***/ function(module, exports) {

	/*****************************************
	
	jQuery.ccl_tab
	version 2.0
	Hiroshi Fukuda <dada@sygnas.jp>
	http://sygnas.jp/
	
	The MIT License
	
	Copyright (c) 2011-2012 Hiroshi Fukuda, http://sygnas.jp/
	
	/*****************************************
	
	
	/*****************************************
	
	タブナビゲーションを実装。
	・data-ccltab-content 属性でターゲットとなるコンテンツを指定
	・data-ccltab-hash 属性でURLのハッシュを変更するかを指定
	・data-ccltab-prev 属性で戻るボタンのエレメントを指定
	・data-ccltab-next 属性で進むボタンのエレメントを指定
	・表示エフェクトに関しては全てcssにて行う。
	・非表示状態についてもcssで定義する。
	・タブボタンのリンクで指定するのは #{数字}
	・アクティブなタブには data-ccltab-active="true" が付く
	・アクティブなコンテンツには data-ccltab-show="true" が付く
	
	= example =
	
	<ul class="js-ccltab_tab" data-ccltab-content=".js-ccltab_content" data-ccltab-hash="true">
	    <li><a href="#0">PROFILE</a></li>
	    <li><a href="#1">DISCOGRAPHY</a></li>
	</ul>
	
	<div class="js-ccltab_content">コンテンツ 0</div>
	<div class="js-ccltab_content">コンテンツ 1</div>
	
	<script>
	var CaracolTab = require('./caracol/navigation/jquery.tab.js');
	new CaracolTab('.js-ccltab_tab');
	</script>
	
	
	*****************************************/
	
	/*****************************************
	
	2016.11.29 ver 2.0
		・アクティブ指定は data属性を使うように変更
		・prev / next に対応
	
	2016.07.15 ver 1.0
		・とりあえず作成
	
	*****************************************/
	
	var CaracolTab;
	
	module.exports = CaracolTab = function( target ){
		'use strict';
	
		// 個々のタブでインスタンスを作成
		$(target).each( function(){
			new TabControllClass( this );
		});
	
		/****************************
		* tab control class
		*/
		function TabControllClass( target ){
			'use strict';
	
			var $tab = $(target);
			var $tab_buttons = $tab.find('a');
			var $contents = $( $tab.data('ccltab-content') );
			var $prev = $tab.data('ccltab-prev') ? $( $tab.data('ccltab-prev') ) : null;
			var $next = $tab.data('ccltab-next') ? $( $tab.data('ccltab-next') ) : null;
			var config = {
				hash: $tab.data('ccltab-hash') === true ? true : false
			};
			// 現在アクティブなコンテンツ
			var now = null;
	
			// 最初のタブをアクティブに
			check_url_hash();
	
			// タブをクリックした
			$tab.find('a').on('click', function(){
				var index = this.hash.substr(1);
				set_active_from_index( index );
				return false;
			});
	
			// prev / next をクリックした
			if( $prev ){
				$prev.on('click', function(){
					var index = Math.min( now + 1, $contents.length - 1 );
					set_active_from_index( index );
				});
			}
	
			if( $next ){
				$next.on('click', function(){
					var index = Math.max( now - 1, 0 );
					set_active_from_index( index );
				});
			}
	
			// 指定した index のタブをアクティブにする
			function set_active_from_index( index ){
				'use strict';
	
				// タブとコンテンツにアクティブ属性付与
				if( now !== null ){
					$tab_buttons.eq(now).attr('data-ccltab-active', '');
					$contents.eq(now).attr('data-ccltab-show', '');
				}
				$tab_buttons.eq(index).attr('data-ccltab-active', 'true');
				$contents.eq(index).attr('data-ccltab-show', 'true');
	
				// URLにハッシュ付与
				if( config.hash ){
					window.location.hash = index;
				}
				now = index;
			}
	
			// 登録時にURLハッシュをチェックする
			function check_url_hash(){
				'use strict';
	
				if( config.hash ){
					var hash = window.location.hash.substr(1);
	
					// ハッシュが番号だったら該当コンテンツを開く
					if( !isNaN(hash) && hash.length ){
						set_active_from_index(hash);
						return;
					}
				}
				// デフォルトでは最初のコンテンツをアクティブにする
				set_active_from_index(0);
			}
		}
	};
	


/***/ },
/* 5 */
/***/ function(module, exports) {

	/*****************************
	上下スクロールで対象にクラスを付与するクラス
	ver 1.0.0
	
	メニューや、トップに戻るボタンの出し入れに使う。
	
	# usage
	var scroll_amount = new CaracolScrollAmount( target, {config} );
	
	## target
	検知対象となる element
	
	## config
	パラメーター。値は初期値。
	
	{
		up: 80,  // 上へのスクロールに反応するスクロール積算値。
		down: 80,  // 下へのスクロールに反応するスクロール積算値。
		offset_top: 50, // スクロール位置がこの値より上ならページ最上部と判断
		offset_bottom: 50, // スクロール位置がこの値より下ならページ最下部と判断
	
		// 状態によって付与されるクラス
		class:{
			pinned: 'ccl-amount_pinned',
			unpinned: 'ccl-amount_unpinned',
			top: 'ccl-amount_top',
			nottop: 'ccl-amount_not-top',
			bottom: 'ccl-amount_bottom',
			notbottom: 'ccl-amount_not-bottom',
			initial: 'ccl-amount'
		},
	
		// イベント
		onPin: function(){},
		onUnPin: function(){},
		onTop: function(){},
		onNotTop: function(){},
		onBottom: function(){},
		onNotBottom: function(){}
	}
	
	------------------------
	ver1.0.0 2016/11/22
	- とりあえず作った。
	
	*/
	var CaracolScrollAmount;
	
	module.exports = CaracolScrollAmount = function( target, config ){
		'use strict';
	
		var defaults = {
			up: 80,
			down: 80,
			offset_top: 70,
			offset_bottom: 70,
	
			// 状態によって付与されるクラス
			class:{
				pinned: 'ccl-amount_pinned',
				unpinned: 'ccl-amount_unpinned',
				top: 'ccl-amount_top',
				nottop: 'ccl-amount_not-top',
				bottom: 'ccl-amount_bottom',
				notbottom: 'ccl-amount_not-bottom',
				initial: 'ccl-amount'
			},
			// イベント
			onPin: function(){},
			onUnPin: function(){},
			onTop: function(){},
			onNotTop: function(){},
			onBottom: function(){},
			onNotBottom: function(){}
		};
	
		this.opt = $.extend( defaults, config );
		this.target = target;
		this.$target = $(target);
		this.$window =$(window);
		this.win_height = null;	// ブラウザウィンドウの高さ
		// this.doc_height = null;	// ドキュメントの高さ
		this.last_scroll = 0; // 1回前の座標
		this.count_scroll = 0; // スクロール量の積算
	
		this.is_started = false; // 開始した
		this.is_top = false; // 一番上にスクロールした
		this.is_bottom = false; // 一番下にスクロールした
		this.is_pinned = false; // ピンを立てた
	
		// 開始
		this.start();
	};
	
	/********************
	* スクロール検知処理を開始
	*/
	CaracolScrollAmount.prototype.start = function(){
		'use strict';
	
		// すでに開始していたら無視
		if( this.is_started ) return;
	
		// 基礎クラスを付与
		this.$target.addClass( this.opt.class.initial );
	
		// リサイズイベントでドキュメント高さチェック
		this.resize();
		this.$window.on('resize', $.throttle( 100, $.proxy( this.resize, this )));
	
		// スクロールイベント
		this.scroll();
		this.is_started = true;
		this.$window.on('scroll', $.throttle( 100, $.proxy( this.scroll, this )));
	
		// 一応1秒間毎にチェックも入れる
		setInterval( $.proxy( this.scroll, this ), 1000 );
	};
	
	/********************
	* スクロール検知処理を停止
	*/
	CaracolScrollAmount.prototype.stop = function(){
		'use strict';
		this.$window.off( 'scroll', _.throttle( $.proxy( this.scroll, this ), 50 ) );
	};
	/********************
	* スクロール処理
	*/
	CaracolScrollAmount.prototype.scroll = function(){
		'use strict';
	
		var opt = this.opt;
		var scroll = this.$window.scrollTop();
		var distance = scroll - this.last_scroll; // 移動量
	
		// 位置イベントのチェック
		this.check_top_bottom( scroll );
	
		// スクロール量を積算。もし逆方向にスクロールしたらリセット
		if( this.count_scroll > 0 && distance > 0 ){
			this.count_scroll += distance;
		}else if( this.count_scroll < 0 && distance < 0 ){
			this.count_scroll += distance;
		}else{
			this.count_scroll = distance;
		}
	
		this.last_scroll = scroll;
	
		// スクロールが規定量越えたらピンを立てる
		if(  this.count_scroll >= opt.down && !this.is_pinned ){
			// 下にスクロール
			this.is_pinned = true;
			this.$target.addClass( opt.class.pinned );
			this.$target.removeClass( opt.class.unpinned );
	
		}else if( this.count_scroll <= -opt.up && this.is_pinned ){
			// 上にスクロ−ル
			this.is_pinned = false;
			this.$target.addClass( opt.class.unpinned );
			this.$target.removeClass( opt.class.pinned );
		}
	
	};
	
	/********************
	* 最上部か最下部かのチェック
	*/
	CaracolScrollAmount.prototype.check_top_bottom = function( scroll ){
		'use strict';
	
		var opt = this.opt;
		var $target = this.$target;
		var scroll_bottom = $(document).height() - this.win_height;
	
	
		if( !this.is_top && scroll <= opt.offset_top ){
			// ページ最上部
			this.is_top = true;
			$target.addClass( opt.class.top );
			$target.removeClass( opt.class.nottop );
			$target.addClass( opt.class.notbottom );
			opt.onTop();
	
		}else if( !this.is_bottom && scroll >= scroll_bottom - opt.offset_bottom){
			// ページ最下部
			this.is_bottom = true;
			$target.addClass( opt.class.bottom );
			$target.addClass( opt.class.nottop );
			$target.removeClass( opt.class.notbottom );
			opt.onBottom();
	
		}else if( this.is_top && scroll > opt.offset_top ){
			// 最上部から離れた
			this.is_top = false;
			$target.addClass( opt.class.nottop );
			$target.removeClass( opt.class.top );
			opt.onNotTop();
	
		}else if( this.is_bottom && scroll < scroll_bottom - opt.offset_bottom ){
			// 最下部から離れた
			this.is_bottom = false;
			$target.addClass( opt.class.notbottom );
			$target.removeClass( opt.class.bottom );
			opt.onNotBottom();
		}
	};
	
	
	/********************
	* ウィンドウをリサイズしたら高さなどをチェック
	*/
	CaracolScrollAmount.prototype.resize = function(){
		this.win_height = this.$window.height();
	}
	


/***/ },
/* 6 */
/***/ function(module, exports) {

	/*****************************************
	
	jQuery.syg_pagescroll
	version 1.3
	Hiroshi Fukuda <dada@sygnas.jp>
	http://sygnas.jp/
	
	The MIT License
	
	Copyright (c) 2011-2012 Hiroshi Fukuda, http://sygnas.jp/
	
	/*****************************************
	
	
	/*****************************************
	= example 1 =
	
		<a href="#hogehoge">hogehoge</a>
	
		<div id="hogehoge">
		</div>
	
		<script src="lib/jquery.syg_pagescroll.1.0.js"></script>
		<script>
			new $.SygPageScroll( 'a' );
		</script>
	
	
	= example 2 =
	
		<a href="#hogehoge" class="scroll">hogehoge</a>
	
		<div id="hogehoge">
		</div>
	
		<script src="lib/jquery.easing.1.3.js"></script>
		<script src="lib/jquery.syg_pagescroll.1.0.js"></script>
		<script>
			new $.SygPageScroll( 'a.scroll', {time:2000, easing:'easeInOutCubic'} );
		</script>
	
	*****************************************/
	
	/*****************************************
	
	2016.11.23 ver.2.1
		・$(target).click(); を $(document).on('click',target,function(){}); に変更
	2016.06.8 ver 2
		・Webpack用に作り直し
	2015.04.26 ver 1.3
		・スクロール先IDが無い場合は普通にリンクさせる
	2013.03.08 ver 1.1
		・位置補正オプション「plus」を追加。
	
	*****************************************/
	
	var CaracolPageScroll;
	
	module.exports = CaracolPageScroll = function( target, config ){
		'use strict';
	
		var defaults = {
			easing:			'swing',
			time:			1000,
			plus:			0
		};
	
		this.opt = $.extend( defaults, config );
	
		var self = this;
		var opt = this.opt;
	
		/*****************************
		* click setting
		*/
		$(document).on('click',target,
			$.proxy(
				function( e ){
					var hash = e.currentTarget.hash;
	
					if( $(hash).get(0) ){
						var y = $(hash).offset().top +opt.plus;
						$('html,body').animate( {scrollTop:y}, self.opt.time, self.opt.easing );
						return false;
					}else{
						return true;
					}
	
				}
			)
		);
	
	};
	


/***/ },
/* 7 */
/***/ function(module, exports) {

	/*
	各種ソーシャルサービスボタンを簡単設置
	
	2016/11/24 ver.2.0.0
		- Webpack対応
	*/
	
	
	exports.set_share_button = function( target ){
		'use strict';
	
		var window_opt = "width=550, height=450,personalbar=0,toolbar=0,scrollbars=1,resizable=1";
		var e = encodeURIComponent;
	
		// クリック動作
		$(document).on('click', target, function(){
			var $this = $(this);
			var url = $this.data('ccl-share-url');
			var msg = $this.data('ccl-share-msg');
			var via = $this.data('ccl-share-via');
			var flw = $this.data('ccl-share-flw');
	
			if( !url ) url = location.href;
			if( !msg ) msg = document.title;
	
			switch( $this.data('ccl-share-svc') ){
				case 'twitter':
					twitter(url, msg, via, flw); break;
				case 'facebook':
					facebook(url); break;
				case 'line':
					line(url, msg); break;
				case 'feedly':
					feedly(url); break;
				case 'pocket':
					pocket(url); break;
				case 'hatebu':
					hatebu(url, msg); break;
				case 'google':
					google(url); break;
			}
	
			return false;
		});
	
		/***************************
		* Twitter
		*/
		function twitter( url, msg, via, follow ){
		    'use strict';
			var openURL = 'http://twitter.com/share?url=' + e(url) + '&text=' + e(msg) + '+';
			if( via ) openURL += '&via=' + e(via);
			if( follow ) openURL += '&related=' + e(follow);
			window.open( openURL, 'tweetwindow', window_opt );
			return false;
		}
	
		/***************************
		* Facebook
		*/
		function facebook( url ){
		    'use strict';
			var openURL = 'http://www.facebook.com/share.php?u='+ e(url);
			window.open( openURL, 'facebookwindow', window_opt );
			return false;
		}
	
		/***************************
		* LINE
		*/
		function line( url, msg ){
		    'use strict';
			window.location.href = 'line://msg/text/' + e(msg) + ' ' + e(url);
			return false;
		}
	
		/***************************
		* feedly
		*/
		function feedly( url ){
		    'use strict';
			var openURL = 'http://feedly.com/i/subscription/feed/' + e(url);
			window.open( openURL, 'feedlywindow', window_opt );
			return false;
		}
	
		/***************************
		* Pocket
		*/
		function pocket( url ){
		    'use strict';
			var openURL = 'http://getpocket.com/edit?url=' + e(url);
			window.open( openURL, 'feedlywindow', window_opt );
			return false;
		}
	
		/***************************
		* はてなブックマーク
	    <li class="hatebu"><a expr:href='"http://b.hatena.ne.jp/add?mode=confirm&amp;url=" + data:post.canonicalUrl + "&amp;" + data:post.title + "｜" + data:blog.title' target="_blank" onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;"><i class="fa">B!</i><br/>はてブ</a></li>
	
	http://b.hatena.ne.jp/add?mode=confirm&amp;url=http%3A%2F%2Fgo-taiwan.localhost%3A8080%2Fsanxia%2F&amp;%E5%8F%B0%E6%B9%BE%E3%81%AE%E3%83%9E%E3%82%A4%E3%83%8A%E3%83%BC%E8%A6%B3%E5%85%89%E5%90%8D%E6%89%80%E3%83%BB%E4%B8%89%E5%B3%BD%E3%81%AE%E8%A6%8B%E6%89%80%E3%81%A8%E3%82%B0%E3%83%AB%E3%83%A1%E3%82%92%E7%B4%B9%E4%BB%8B%EF%BC%81%20%20%7C%20%20%E3%81%A1%E3%82%87%E3%81%A3%E3%81%A8%E5%8F%B0%E6%B9%BE%E3%81%84%E3%81%A3%E3%81%A6%E3%81%8D%E3%81%BE%E3%81%99%E2%88%92%E5%8F%B0%E6%B9%BE%E6%97%85%E8%A1%8C%E3%83%96%E3%83%AD%E3%82%B0%E2%88%92
	
	http://b.hatena.ne.jp/add?mode=confirm&url=http%3A%2F%2Fgo-taiwan.localhost%3A8080%2Fsanxia%2F&%E5%8F%B0%E6%B9%BE%E3%81%AE%E3%83%9E%E3%82%A4%E3%83%8A%E3%83%BC%E8%A6%B3%E5%85%89%E5%90%8D%E6%89%80%E3%83%BB%E4%B8%89%E5%B3%BD%E3%81%AE%E8%A6%8B%E6%89%80%E3%81%A8%E3%82%B0%E3%83%AB%E3%83%A1%E3%82%92%E7%B4%B9%E4%BB%8B%EF%BC%81%20%20%7C%20%20%E3%81%A1%E3%82%87%E3%81%A3%E3%81%A8%E5%8F%B0%E6%B9%BE%E3%81%84%E3%81%A3%E3%81%A6%E3%81%8D%E3%81%BE%E3%81%99%E2%88%92%E5%8F%B0%E6%B9%BE%E6%97%85%E8%A1%8C%E3%83%96%E3%83%AD%E3%82%B0%E2%88%92
			var openURL = 'http://twitter.com/share?url=' + e(url) + '&text=' + e(msg) + '+';
	
		*/
		function hatebu( url, msg ){
		    'use strict';
			var openURL = '//b.hatena.ne.jp/add?mode=confirm&url=' + e(url) + "&title=" + e(msg);
			// var openURL = '//b.hatena.ne.jp/entry/' + e(url);
			window.open( openURL, 'hatebuwindow', window_opt );
			return false;
		}
	
		/***************************
		* google plus
		*/
		function google( url ){
		    'use strict';
			var openURL = 'https://plus.google.com/share?url=' + e(url);
			window.open( openURL, 'googlewindow', window_opt );
			return false;
		}
	
	};

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bundle.js
 **/